import { combineEpics } from 'redux-observable';

import resetBookingFlowEpic from './resetBookingFlow';

export default combineEpics(resetBookingFlowEpic);
